import { render, staticRenderFns } from "./EditarParticipantesVencedoresItensLicitacao.vue?vue&type=template&id=49dbc257"
import script from "./EditarParticipantesVencedoresItensLicitacao.vue?vue&type=script&lang=ts"
export * from "./EditarParticipantesVencedoresItensLicitacao.vue?vue&type=script&lang=ts"
import style0 from "./EditarParticipantesVencedoresItensLicitacao.vue?vue&type=style&index=0&id=49dbc257&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports